import Vue from "vue";
import Router from "vue-router";
import environment from "./env.js";
import Entrance from "./views/Entrance.vue";
import Home from "./views/Home";
import store from "./store/store";
import Tiho from "./views/Tiho";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,

    routes: [
        {
            path: "/index.html",
            name: "Home",
            alias: "/",
            component: Home,
            meta: {
                requires_dev_auth: true
            }
        },
        {
            path: "/tiho",
            name: "TiHo",
            component: Tiho,
            meta: {
                requires_dev_auth: true
            }
        },
        {
            path: "/entrance",
            name: "Entrance",
            component: Entrance,
            meta: {
                requires_dev_auth: false
            }
        },
        {
            path: "*",
            redirect: "/"
        }
    ]
});

//apply navigation-guard for dev and staging environments
if (environment === "dev" || environment === "staging") {
    router.beforeEach((to, from, next) => {
        if (to.matched.some(record => record.meta.requires_dev_auth)) {
            if (!store.getters["user/is_dev_authenticated"]) {
                window.location = "https://vetvise.com";
            } else {
                next();
            }
        } else {
            next();
        }
    });
}

export default router;